<template>
  <div class="title brown">
    <div class="en">{{en}}</div>
    <div class="cht">
      <span class="orange">{{chtFirst}}</span>
      {{chtSecond}}
    </div>
    <div
      class="line_box"
      :style="center ? 'justify-content: center;' : 'justify-content: flex-start'"
    >
      <div class="line"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Title",
  props: ["en", "chtFirst", "chtSecond", "center"]
};
</script>
<style scoped>
.title {
  display: inline-block;
}
.title .cht {
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 2rem;
}
.title .line_box {
  display: flex;
}
.title .line_box .line {
  width: 5px;
  height: 25px;
  background-color: #bab1a2;
}
.orange {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Title.vue